


export const Discount_START = 'Discount_START';
export const Discount_END = 'Discount_END';
export const Discount_ERROR = 'Discount_ERROR';
export const Discount_SUCCESS = 'Discount_SUCCESS';
export const Discount_FAIL = 'Discount_FAIL';
export const IsDataSubmitedSuccessfully ='IsDataSubmitedSuccessfully';
export const IsPromosAddedSuccess ='IsPromosAddedSuccess';